import { createActionCreator } from "deox";
import {
  IEntityRepeatModel,
  ITransactionInfoModel,
} from "../../../types/types";

// Client Repeats
export const clientRepeatsLoading = createActionCreator(
  "repeatsAndReferrers/clientRepeatsLoading",
);
export const clientRepeatsLoaded = createActionCreator(
  "repeatsAndReferrers/clientRepeatsLoaded",
  (resolve) => (payload: IEntityRepeatModel[]) => resolve(payload),
);
export const clientRepeatsError = createActionCreator(
  "repeatsAndReferrers/clientRepeatsError",
  (resolve) => (error: string) => resolve(error),
);

// SOI Referrers
export const soiReferrersLoading = createActionCreator(
  "repeatsAndReferrers/soiReferrersLoading",
);
export const soiReferrersLoaded = createActionCreator(
  "repeatsAndReferrers/soiReferrersLoaded",
  (resolve) => (payload: IEntityRepeatModel[]) => resolve(payload),
);
export const soiReferrersError = createActionCreator(
  "repeatsAndReferrers/soiReferrersError",
  (resolve) => (error: string) => resolve(error),
);

// Vendor Referrers
export const vendorReferrersLoading = createActionCreator(
  "repeatsAndReferrers/vendorReferrersLoading",
);
export const vendorReferrersLoaded = createActionCreator(
  "repeatsAndReferrers/vendorReferrersLoaded",
  (resolve) => (payload: IEntityRepeatModel[]) => resolve(payload),
);
export const vendorReferrersError = createActionCreator(
  "repeatsAndReferrers/vendorReferrersError",
  (resolve) => (error: string) => resolve(error),
);

// Agent Referrers
export const agentReferrersLoading = createActionCreator(
  "repeatsAndReferrers/agentReferrersLoading",
);
export const agentReferrersLoaded = createActionCreator(
  "repeatsAndReferrers/agentReferrersLoaded",
  (resolve) => (payload: IEntityRepeatModel[]) => resolve(payload),
);
export const agentReferrersError = createActionCreator(
  "repeatsAndReferrers/agentReferrersError",
  (resolve) => (error: string) => resolve(error),
);

// Selected Transactions
export const selectedTransactionsLoading = createActionCreator(
  "repeatsAndReferrers/selectedTransactionsLoading",
);
export const selectedTransactionsLoaded = createActionCreator(
  "repeatsAndReferrers/selectedTransactionsLoaded",
  (resolve) => (payload: ITransactionInfoModel[]) => resolve(payload),
);
export const selectedTransactionsError = createActionCreator(
  "repeatsAndReferrers/selectedTransactionsError",
  (resolve) => (error: string) => resolve(error),
);
export const selectedTransactionsCleared = createActionCreator(
  "repeatsAndReferrers/selectedTransactionsCleared",
);

export const agentReferreredLoading = createActionCreator(
  "repeatsAndReferrers/agentReferreredLoading",
);
export const agentReferreredLoaded = createActionCreator(
  "repeatsAndReferrers/agentReferreredLoaded",
  (resolve) => (payload: IEntityRepeatModel[]) => resolve(payload),
);
export const agentReferreredError = createActionCreator(
  "repeatsAndReferrers/agentReferreredError",
  (resolve) => (error: string) => resolve(error),
);

// Combined Repeats and Referrers
export const combinedRepeatsAndReferrersLoading = createActionCreator(
  "repeatsAndReferrers/combinedRepeatsAndReferrersLoading",
);
export const combinedRepeatsAndReferrersLoaded = createActionCreator(
  "repeatsAndReferrers/combinedRepeatsAndReferrersLoaded",
  (resolve) => (payload: IEntityRepeatModel[]) => resolve(payload),
);
export const combinedRepeatsAndReferrersError = createActionCreator(
  "repeatsAndReferrers/combinedRepeatsAndReferrersError",
  (resolve) => (error: string) => resolve(error),
);
